/* eslint-disable camelcase */
export default {
    en: {
        title: 'Ask for opportunities',
        description: 'Describe your perfect job and we use it as insights to find you the best opportunities',
        inputPlaceholder: 'Ex., ‘Bell ringer in medieval castle in north Norway for this summer’',
        send: 'Send',
        successToastText: 'Sent successfully'
    },
    no: {
        title: 'Spør etter muligheter',
        description: 'Beskriv din perfekte jobb, og vi bruker den som innsikt for å finne de beste mulighetene for deg',
        inputPlaceholder: 'Eks., ‘Klokker på middelalderslott i Nord-Norge for denne sommeren’',
        send: 'Send',
        successToastText: 'Sendt vellykket'
    },
    sv: {
        title: 'Fråga efter möjligheter',
        description: 'Beskriv ditt perfekta jobb och vi använder det som insikter för att hitta de bästa möjligheterna för dig',
        inputPlaceholder: 'Ex., ‘Klockare i medeltida slott i norra Norge för i sommar’',
        send: 'Skicka',
        successToastText: 'Skickat framgångsrikt'
    }
} as const;
